import styled from "styled-components";

export const Root = styled.div`
  position: relative;
`;

export const PlainText = styled.span``;

export const KeyWords = styled.span`
  font-weight: 600;
`;
